<template>
  <div>
    <div v-show="!isLoading" class="myresources">
      <md-dialog :md-active.sync="showModal" >
        <md-dialog-title style="color:#3c7f1f; font-weight: 600">新增資料夾</md-dialog-title>
        <form style="margin: 1rem 2rem;">
          <md-field class="md-primary">
            <label>資料夾名稱</label>
            <md-input name="folderName" v-model="folderName" required></md-input>
          </md-field>
          <md-field class="md-primary">
            <label>描述（選填）</label>
            <md-textarea name="folderDescription" v-model="folderDescription"></md-textarea>
          </md-field>
        </form>
        <md-dialog-actions style="margin: 1rem auto">
          <md-button class="md-primary" style="color:#3c7f1f" @click="showModal = false">取消</md-button>
          <md-button class="md-primary" style="color:#3c7f1f" @click="showModal = false">新增</md-button>
        </md-dialog-actions>
      </md-dialog>
      <md-dialog :md-active.sync="showAddResourceModal" >
        <md-dialog-title style="color:#3c7f1f; font-weight: 600">新增資源</md-dialog-title>
        <form id="resourceForm" style="margin: 1rem 2rem;">
          <md-field class="md-primary">
            <label>資源</label>
            <md-file accept="*/*" name="upload_material"/>
          </md-field>
          <md-field class="md-primary">
            <label>資源名稱</label>
            <md-input name="name" v-model="resourceName" required></md-input>
          </md-field>
          <md-field>
            <label for="resourceType">資源類型</label>
            <md-select v-model="resourceType">
              <md-option value="video">影片</md-option>
              <md-option value="file">檔案</md-option>
            </md-select>
          </md-field>
          <md-field class="md-primary">
            <label>描述（選填）</label>
            <md-textarea name="description" v-model="resourceDescription"></md-textarea>
          </md-field>
        </form>
        <md-dialog-actions style="margin: 1rem 0">
          <div class="col-xs-6" style="text-align: center;">
            <el-button plain @click="showAddResourceModal = false">取消</el-button>
          </div>
          <div class="col-xs-6" style="text-align: center;">
            <el-button type="primary" @click="addResource">新增</el-button>
          </div>
        </md-dialog-actions>
      </md-dialog>

      <div class="myresources-uploadbtns">
        <!--<div class="myresources-btn">上載檔案</div>-->
        <div class="myresources-title" style="align-self: center;">我的資源</div>
        <div style="display: flex;">
          <div v-if="false" class="myresources-btn" @click="showModal = true">新增資料夾</div>
          <div v-if="folders.length > 0" class="myresources-btn" @click="showAddResourceModal = true">新增資源</div>
        </div>
      </div>
      <div style="display: flex; flex-wrap: wrap;">
        <div v-for="file in file_list" :key="file.file_id" class="myresources-filebtn"><router-link :to="{path: '/resources/self?folder=' + file.file_id}"><div style="color:white">{{file.file_name}}</div></router-link></div>
      </div>
      <div>
        <VideoPool v-show="folders.length > 0" :folders="folders" :showFilter="false" :buttons="buttonEnabled" :actions="actions"></VideoPool>
        <div v-show="folders.length == 0" style="display: flex; text-align: center;">
          <div style="margin: 5rem auto;" class="myresources-btn" @click="showAddResourceModal = true">新增資源</div>
        </div>
      </div>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>

<style lang="scss" scoped>
  .myresources{
    width: 80%;
    max-width: 1024px;
    margin: 2rem auto;
    padding-right: 2rem;
  }
  .myresources-uploadbtns{
    display: flex;
    justify-content: space-between;
  }
  .myresources-title{
    font-size: 1.5rem;
    font-weight: 600;
    color: #397f1f;
  }
  .myresources-btn{
    margin: 1rem;
    background-color: #3c7f1f;
    color: white;
    font-size: 1.2rem;
    padding: 1rem 1.5rem;
    border-radius: 0.8rem;
  }
  .myresources-btn:hover{
    cursor: pointer;
  }
  .myresources-filebtns{
    display: flex;
    flex-direction: row;
  }
  .myresources-filebtn{
    margin: 0.8rem;
    background-color: #3c7f1f;
    color: white;
    font-size: 1.2rem;
    text-align: center;
    padding: 4rem 0;
    border-radius: 0.8rem;
    flex: 0 0 15rem;
  }
  .myresources-fileTitle{
    font-size: 1.3rem;
    color: #3c7f1f;
    font-weight: 600;
    margin: 1.5rem 0;
  }
  .myresources-fileContent{
    border: 1px solid #99cc33;
    border-radius: 1.5rem;
  }
</style>
<script>
// import vuescroll from 'vuescroll'
import VideoPool from '@/components/Video/VideoPool.vue'
import Loading from '@/components/Utility/Loading.vue'
export default {
  components: {
    //  vuescroll,
    Loading,
    VideoPool
  },
  data () {
    return {
      resourceType: 'video',
      resourceName: '',
      resourceDescription: '',
      folderName: '',
      folderDescription: '',
      showModal: false,
      showAddResourceModal: false,
      ops: {
        vuescroll: {},
        scrollPanel: {
          scrollingX: false
        },
        rail: {},
        bar: {
          background: '#99CB32',
          opacity: 0.8
        }
      },
      opsfile: {
        vuescroll: {},
        scrollPanel: {
          scrollingY: false
        },
        rail: {
        },
        bar: {
          background: '#99CB32',
          opacity: 0.8,
          keepShow: true
        }
      },
      file_list: [],
      folders: [],
      buttonEnabled: {
        like: false,
        bookmark: true,
        download: true
      },
      actions: [{
      //   fn: this.addMission,
      //   name: '增加任務'
      // },
      // {
        fn: this.goToVideoDetail,
        name: '觀看影片'
      }],
      isLoading: true
    }
  },
  computed: {
    folder_id: function () {
      return parseInt(this.$route.query.folder)
    }
  },
  methods: {
    addResource: async function () {
      if (!confirm('確定提交？')) {
        return
      }
      try {
        this.isLoading = true
        let fd = new FormData(document.getElementById('resourceForm'))
        fd.append('type', this.resourceType)
        console.log(Array.from(fd.entries()))
        console.log(this.resourceType)
        let video = await this.$store.dispatch('request', {
          method: 'post',
          route: `resources/self`,
          data: fd
        })
        this.showAddResourceModal = false
        this.folders.push(video)
      } catch (err) {
        console.error(err)
        alert('失敗')
      }
      this.isLoading = false
    },
    goToVideoDetail: function (file) {
      console.log(this.$router)
      this.$router.push({
        name: 'Video',
        query: {
          subject: file.parent_id,
          file: file.info.id
        }
      })
      console.log(file)
    }
  },
  async mounted () {
    await this.$store.dispatch('request', {
      route: `resources/self`
    }).then(result => {
      console.log(result)
      this.folders = result.sub_folders
    })
    this.isLoading = false
  }
}
</script>
